import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CRMIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "23",
        height: "16",
        viewBox: "0 0 23 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5578 13.8771C11.0537 13.5037 10.5939 13.0675 10.1906 12.576C9.2082 11.379 8.61331 9.91794 8.4751 8.38625L16.1387 8.3861C16.5206 8.38594 16.8301 8.07632 16.8301 7.69444C16.83 6.1314 16.4262 4.58539 15.6456 3.21107C15.0177 2.10568 14.1696 1.15278 13.1632 0.405634C13.902 0.161758 14.6916 0.0297852 15.5121 0.0297852C19.6475 0.0297852 22.9999 3.38216 22.9999 7.51752C22.9999 11.6529 19.6475 15.0053 15.5121 15.0053C14.0605 15.0053 12.7053 14.5922 11.5578 13.8771Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.000488281 7.69457C0.000488281 3.44498 3.44546 0 7.69506 0C9.08159 0 10.3806 0.366118 11.5027 1.00651C11.5155 1.01504 11.5285 1.02318 11.5419 1.03092C12.7213 1.71185 13.7055 2.69767 14.3852 3.89428C14.9314 4.8559 15.26 5.91671 15.358 7.00297H7.69471C7.31272 7.00297 7.00306 7.31263 7.00306 7.69461C7.00306 9.79483 7.73128 11.8301 9.06365 13.4536C9.49381 13.9777 9.97835 14.4485 10.5066 14.8595C9.63621 15.2013 8.68809 15.3891 7.69506 15.3891C3.44546 15.3891 0.000488281 11.9442 0.000488281 7.69457Z",
                fill: "white"
            })
        ]
    });
export default CRMIcon;
